import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row research-items-container iodine-padding-left-sm iodine-padding-right-sm" }
const _hoisted_2 = { class: "research-items-more row iodine-padding-top-sm iodine-padding-left-md" }

import ResearchItem from 'components/resources/ResearchItem.vue';
    import {ResearchSectionDataModel} from 'components/resources/ResearchSectionData.model';
    import {ref, Ref} from 'vue';

    export interface Props {
        researchSectionDataModel: ResearchSectionDataModel,
        othersExpanded?: boolean
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchSectionContainer',
  props: {
    researchSectionDataModel: { default: null },
    othersExpanded: { type: Boolean, default: false }
  },
  setup(__props: any) {

    const props = __props;

    const othersExpanded: Ref<boolean> = ref(props.othersExpanded)


return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createBlock(_component_q_expansion_item, { id: "research-section-container" }, {
    header: _withCtx(() => [
      _createVNode(_component_q_item_section, { class: "research-section-title" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.researchSectionDataModel.title), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_list, { dense: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.researchSectionDataModel.best, (item) => {
              return (_openBlock(), _createBlock(_component_q_item, {
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createVNode(ResearchItem, { "research-item-data-model": item }, null, 8, ["research-item-data-model"])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.researchSectionDataModel.others, (item) => {
              return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createVNode(ResearchItem, { "research-item-data-model": item }, null, 8, ["research-item-data-model"])
                ]),
                _: 2
              }, 1024)), [
                [_vShow, othersExpanded.value]
              ])
            }), 128)),
            _withDirectives(_createElementVNode("div", _hoisted_2, [
              _withDirectives(_createElementVNode("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (othersExpanded.value = true))
              }, [
                _createTextVNode(" Show All Matches (" + _toDisplayString(props.researchSectionDataModel.bestCount + props.researchSectionDataModel.othersCount) + ")   ", 1),
                _createVNode(_component_q_icon, {
                  name: "fa-solid fa-angle-down",
                  class: "iodine-small-icon"
                })
              ], 512), [
                [_vShow, !othersExpanded.value]
              ]),
              _withDirectives(_createElementVNode("a", {
                href: "#",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (othersExpanded.value = false))
              }, [
                _createTextVNode(" Show Top Matches Only (" + _toDisplayString(props.researchSectionDataModel.bestCount) + ")   ", 1),
                _createVNode(_component_q_icon, {
                  name: "fa-solid fa-angle-up",
                  class: "iodine-small-icon"
                })
              ], 512), [
                [_vShow, othersExpanded.value]
              ])
            ], 512), [
              [_vShow, props.researchSectionDataModel.othersCount > 0]
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})